<template>
  <div class="Public-Music" :title="Music.Title" :style="MusicStyle.divStyle">
    <div class="Back" :style="MusicStyle.BackStyle" v-on:click="MusicPage"><i class="fa fa-angle-down"></i></div>
    <span class="AlbumImage" :style="MusicStyle.AlbumStyle" v-on:click="MusicPage"><img
        :src="MusicContent[MusicState.Now].AlbumSrc"
        :title="Music.Album"
        :style="MusicStyle.AlbumImageStyle"></span>
    <span class="Song" :style="MusicStyle.SongStyle" v-on:click="MusicPage"><b
        class="SongName">{{ MusicContent[MusicState.Now].Name }}</b> - <b
        class="Singer">{{ MusicContent[MusicState.Now].Singer }}</b><b class="Album"
                                                                       :style="MusicStyle.AlbumIntroStyle">《{{
        MusicContent[MusicState.Now].Album
      }}》</b></span>
    <span class="MusicButton" :style="MusicStyle.MusicButtonStyle">
      <i class="fa fa-arrow-left" v-on:click="LastMusic" :title="Music.LastMusic"></i>
      <i :class="MusicState.Classname" v-on:click="PlayMusic" :title="Music.PlayMusic"></i>
      <i class="fa fa-arrow-right" v-on:click="NextMusic" :title="Music.NextMusic"></i>
      <i class="fa fa-list-ul" v-on:click="ShowMusicList" :title="Music.MusicList"></i>
    </span>
    <div class="MusicList" :style="MusicListStyle">
            <span class="Song" :title="MusicContent.SwitchMusic" v-for="content in MusicContent"
                  v-on:click="SwitchMusic(MusicContent.indexOf(content))"
                  :style="{backgroundColor:MusicContent.indexOf(content)===MusicState.Now?'deepskyblue':''}">{{
                MusicContent.indexOf(content) + 1
              }}. <b
                  class="SongName">{{ content.Name }}</b> - <b
                  class="Singer">{{ content.Singer }}</b><b class="Album">《{{
                  content.Album
                }}》</b></span>
    </div>
    <audio autoplay id="musicaudio" :src="MusicContent[MusicState.Now].Src"
           v-on:timeupdate="MusicProcessCalculate">
    </audio>
    <div class="MusicDuration" :style="MusicStyle.MusicDurationStyle">
      <div class="NowDuration" :style="MusicStyle.NowDurationStyle">
        {{ MusicState.NowDuration }}
      </div>
      <div class="MusicProcessCover" :style="MusicStyle.MusicProcessCoverStyle">
        <div class="MusicProcess" :style="MusicStyle.MusicProcessStyleWidth+MusicStyle.MusicProcessStyle">
          <div class="ProcessCircle" :style="MusicStyle.MusicProcessCircleStyle"></div>
        </div>
      </div>
      <div class="TotalDuration" :style="MusicStyle.TotalDurationStyle">{{ MusicState.TotalDuration }}</div>
    </div>
  </div>
</template>

<script>
var MusicStyle = {
  divStyle: "",
  BackStyle: "",
  AlbumStyle: "",
  AlbumImageStyle: "",
  SongStyle: "",
  AlbumIntroStyle: "",
  MusicButtonStyle: "",
  MusicDurationStyle: "",
  NowDurationStyle: "",
  TotalDurationStyle: "",
  MusicProcessStyle: "",
  MusicProcessStyleWidth: "",
  MusicProcessCircleStyle: "",
  MusicProcessCoverStyle: "",
};
var MusicState = {
  Classname: "fa fa-spin fa-music",
  State: "play",
  Now: 0,
  NowDuration: "00:00",//当前播放位置
  TotalDuration: "∞"//获取音乐时长
};
var MusicContent = [
  {
    Name: "Cloudyな午後",
    Singer: "中原めいこ",
    Album: "Lotos ロートスの果実",
    AlbumSrc: "https://y.qq.com/music/photo_new/T002R300x300M0000013QWx72cGT7r_1.jpg?max_age=2592000",
    Src: "/Music/Cloudyな午後.mp3"
  },
  {
    Name: "Love Like You Care",
    Singer: "Perlo",
    Album: "Day by Day",
    AlbumSrc: "https://y.qq.com/music/photo_new/T002R300x300M000004C8NwG0W05cf_2.jpg?max_age=2592000",
    Src: "/Music/Love Like You Care.mp3"
  },
  {
    Name: "Fortune -銀の月夜のハネムーン-",
    Singer: "中原めいこ",
    Album: "ON THE PLANET",
    AlbumSrc: "https://y.qq.com/music/photo_new/T002R300x300M0000004CxmH0aKJXf.jpg?max_age=2592000",
    Src: "/Music/Fortune -銀の月夜のハネムーン-.mp3"
  }, {
    Name: "Miami Dream - Don't be shy -",
    Singer: "中原めいこ",
    Album: "ON THE PLANET",
    AlbumSrc: "https://y.qq.com/music/photo_new/T002R300x300M0000004CxmH0aKJXf.jpg?max_age=2592000",
    Src: "/Music/Miami Dream - Don't be shy -.mp3"
  },
  {
    Name: "Last Train Home",
    Singer: "Pat Metheny Group",
    Album: "エッセンシャル・コレクション~ラスト・トレイン・ホーム",
    AlbumSrc: "https://y.qq.com/music/photo_new/T002R300x300M000000FLwVL1oHKkk_1.jpg?max_age=2592000",
    Src: "/Music/Last Train Home.mp3"
  },
//   {
//   Name: "奇缘",
//   Singer: "志国 ZGClub",
//   Album: "奇缘SERENDIPITY",
//   AlbumSrc: "http://p1.music.126.net/7n-4FcZ9AmLN4-s4Vql1RA==/109951166065468665.jpg?param=177y177",
//   Src: "/Music/奇缘.mp3"
// },
  {
    Name: "Sax In The Garden",
    Singer: "Quincy Jones",
    Album: "Love, Q",
    AlbumSrc: "https://y.qq.com/music/photo_new/T002R300x300M000004eXS7Q3hLdHX_1.jpg?max_age=2592000",
    Src: "/Music/Sax In The Garden.mp3"
  }, {
    Name: "A Day at the Beach",
    Singer: "j'san./Pandrezz",
    Album: "Hometown",
    AlbumSrc: "https://y.qq.com/music/photo_new/T002R300x300M000000mmPVm01cCbN_2.jpg?max_age=2592000",
    Src: "/Music/A Day at the Beach.mp3"
  },
  {
    Name: "9月の海",
    Singer: "具岛直子",
    Album: "magic wave~具島直子ベスト",
    AlbumSrc: "https://y.qq.com/music/photo_new/T002R300x300M000003iChwc1FRE0L_2.jpg?max_age=2592000",
    Src: "/Music/9月の海.mp3"
  }
];
var MusicListStyle = "display:none;";
export default {
  data() {
    return {
      MusicStyle: MusicStyle,
      MusicState: MusicState,
      MusicContent: MusicContent,
      MusicListStyle: MusicListStyle,
    }
  },
  methods: {
    PlayMusic: function () {//播放/暂停音乐
      var aud = document.getElementById("musicaudio");
      if (this.MusicState.State === "play") {
        aud.pause();
        this.MusicState.Classname = "fa fa-play";
        this.MusicState.State = "pause";
      } else {
        aud.play();
        this.MusicState.Classname = "fa fa-spin fa-music";
        this.MusicState.State = "play";
      }
    },
    LastMusic: function () {//上一首
      this.MusicState.Now = this.MusicState.Now === 0 ? this.MusicContent.length - 1 : this.MusicState.Now - 1;
      this.MusicState.Classname = "fa fa-spin fa-music";
      this.MusicState.State = "play";
    },
    NextMusic: function () {//下一首
      this.MusicState.Now = this.MusicState.Now === this.MusicContent.length - 1 ? 0 : this.MusicState.Now + 1;
      this.MusicState.Classname = "fa fa-spin fa-music";
      this.MusicState.State = "play";
    },
    ShowMusicList: function () {//打开/关闭音乐列表
      this.MusicListStyle = this.MusicListStyle === "display:none;" ? "display:block;" : "display:none;";
    },
    SwitchMusic: function (index) {//点击音乐列表中的音乐并切换
      this.PlayMusic();
      this.MusicState.Classname = "fa fa-spin fa-music";
      this.MusicState.State = "play";
      this.MusicState.Now = index;
    },
    MusicProcessCalculate: function () {//音乐进度条
      var aud = document.getElementById("musicaudio");
      var FullProcess = aud.duration;//获取音乐时长
      var CurrentProcess = aud.currentTime;//获取当前播放位置

      this.MusicStyle.MusicProcessStyleWidth = "width:" + (CurrentProcess / FullProcess) * 100 + "%;";
      if ((CurrentProcess / FullProcess) * 100 > 99.8) {
        this.NextMusic();
      }


      var minutes = "0" + Math.trunc(CurrentProcess / 60);
      var seconds = ""
      if (Math.trunc(CurrentProcess % 60).toString().length !== 2) {
        seconds = '0'
      }
      seconds += Math.trunc(CurrentProcess % 60);
      this.MusicState.NowDuration = minutes + ":" + seconds;
      this.MusicState.TotalDuration = "0" + Math.trunc(FullProcess / 60) + ":" + Math.trunc(FullProcess % 60);
    },
    MusicPage: function () {//展开完整音乐页
      if (this.MusicStyle.divStyle === "") {
        this.MusicStyle.divStyle = "height:100%;bottom:0px;";
        this.MusicStyle.BackStyle = "display:block";
        this.MusicStyle.AlbumStyle = "float:none;"
        this.MusicStyle.AlbumImageStyle = "width: 300px;height: 300px;border:5px solid black;position: fixed;left: 0;right: 0;top: 0;bottom:0;margin: auto;";
        this.MusicStyle.SongStyle = "width:100%;position: fixed;top: 50px;left: 0;right:0;margin:auto;font-size:1.2em;";
        this.MusicStyle.AlbumIntroStyle = "display:block;";
        this.MusicListStyle = "display:none;"
        this.MusicStyle.MusicButtonStyle = "width:80%;position:fixed;bottom:10px;left:0;right:0;margin:auto;font-size:1.7em;";
        this.MusicStyle.MusicDurationStyle = "width:90%;left:0;right:0;bottom:100px;margin:0 auto;";
        this.MusicStyle.NowDurationStyle = "display:inline-block;";
        this.MusicStyle.TotalDurationStyle = "display:inline-block;";
        this.MusicStyle.MusicProcessStyle = "height:10px;bottom:inherit;border-radius: 10px;";
        this.MusicStyle.MusicProcessCircleStyle = "width:10px;height:10px;"
        this.MusicStyle.MusicProcessCoverStyle = "position:unset;width:70%;height:10px;border-radius:10px;bottom:inherit;";
      } else {
        for (let key in this.MusicStyle) {
          this.MusicStyle[key] = "";
        }
      }
    }
  },
  mounted() {
    if (document.documentElement.clientWidth < 800) {//移动设备上,对音乐播放进行初始化控制
      this.PlayMusic();
    }
  },
  computed: {
    Music: function () {
      return this.$store.state.LANGUAGECONTENT.Music;
    }
  }
}
</script>